import React, { useState } from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import Footer from '../../component/layout/Footer';
import emailjs from "@emailjs/browser";

const Appointment = () => {
    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [departmentname, setDepartmentname] = useState("");
    const [doctor, setDoctor] = useState("");
    const [date, setDate] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const departmentnameChange = (e) => {
        const value = e.target.value;
        setDepartmentname(value);
    };
    const dateChange = (e) => {
        const value = e.target.value;
        setDate(value);
    };
    const doctorChange = (e) => {
        const value = e.target.value;
        setDoctor(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(

                "service_4zwjid5",
                "template_hmhcgom",
                "#myForm",
                "TxiVD4ucKTUi0418B"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setDepartmentname("");
                        setDoctor("");
                        setDate("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };
    return (
        <>

            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>Appointment</h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>Appointment</li>
                    </ul>
                </div>
            </section>

            <section className="appointment-section style-two">
                <div className="auto-container">
                    <div className="inner-container">
                        <div className="appointment-box">
                            {/* Sec Title */}
                            <div className="sec-title centered">
                                <div className="sec-title_title">Book Now</div>
                                <h2 className="sec-title_heading">Make An Appointment</h2>
                            </div>
                            {/* Appointment Form */}
                            <div className="appointment-form style-two">
                                {/* Appointment Form */}
                                <form method="POST" onSubmit={sendEmail} id="myForm">
                                    <div className="row clearfix">
                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <input type="text" placeholder="Patient Name*" required
                                                name="from_name"
                                                onChange={(e) => nameChange(e)}
                                                value={name}
                                                id="name"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <input type="text" placeholder="Phone Number*" required
                                                id="phone"
                                                name='phone'
                                                onChange={(e) => numberChange(e)}
                                                value={number}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <input type="email" placeholder="Email Address" required
                                                id="email"
                                                name='email'
                                                onChange={(e) => mailChange(e)}
                                                value={mail}
                                            />
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <input type="text" placeholder="Department Name*" required
                                                name="departmentname"
                                                onChange={(e) => departmentnameChange(e)}
                                                value={departmentname}
                                                id="departmentname"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <input type="text" placeholder="Doctor Name*" required
                                                name="doctor"
                                                onChange={(e) => doctorChange(e)}
                                                value={doctor}
                                                id="doctor"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <input type="text" placeholder="Booking Date*" required
                                                name="date"
                                                onChange={(e) => dateChange(e)}
                                                value={date}
                                                id="date"
                                            />
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                            <textarea className placeholder="Shortly describe the deases"
                                                id="address"
                                                onChange={(e) => massagesChange(e)}
                                                name='massage'
                                                value={massages}
                                                required
                                            />
                                        </div>
                                        <div className="col-lg-12 text-center col-md-12 col-sm-12 form-group">
                                            <button type="submit" name="submit-form" className="theme-btn btn-style-one">

                                                <span className="btn-wrap">
                                                    <span className="text-one">Get Appointment</span>
                                                    <span className="text-two">Get Appointment</span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Appointment